<template>
  <div class="segment-input">
    <template v-for="(val, idx) in values">
      <input
        ref="inputs"
        class="segment-box"
        :maxlength="segmentLength"
        v-model="values[idx]"
        @input="onInput(idx, $event)"
        @focus="onFocus(idx)"
        @keydown.backspace="onBackspace(idx, $event)"
        autocomplete="off"
      />
      <span
        v-if="idx < values.length - 1"
        class="segment-separator"
        :key="'sep' + idx"
      >:</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SegmentInput',
  props: {
    value: { type: String, default: '' }, // v-model
    segments: { type: Number, default: 5 },
    segmentLength: { type: Number, default: 2 }
  },
  data() {
    return {
      values: Array(this.segments).fill('')
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
           let arr = (val || '').split(':').concat(Array(this.segments).fill('')).slice(0, this.segments);
          this.values = arr;
        }else{
          this.values = Array(this.segments).fill('');
        }
      }
    },
    values: {
      deep: true,
      handler() {
        this.$emit('input', this.values.join(':'));
      }
    }
  },
  methods: {
    onInput(idx, e) {
      let val = e.target.value;
      if (val.length > this.segmentLength) {
        val = val.slice(0, this.segmentLength);
        this.values.splice(idx, 1, val);
      }
      // 自动跳到下一个输入框
      if (val.length === this.segmentLength && idx < this.segments - 1) {
        this.$refs.inputs[idx + 1].focus();
      }
    },
    onFocus(idx) {
      // 选中当前输入框内容，便于重新输入
      this.$nextTick(() => {
        this.$refs.inputs[idx].select();
      });
    },
    onBackspace(idx, e) {
      if (e.target.value === '' && idx > 0) {
        this.$refs.inputs[idx - 1].focus();
      }
    }
  }
};
</script>

<style scoped>
.segment-input {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
.segment-box {
  width: 80px;
  height: 48px;
  background: #F5F7FB;
  border: none;
  border-radius: 10px;
  text-align: center;
  font-size: 22px;
  color: #5a6a7a;
  font-family: inherit;
  box-shadow: 0 0 0 0 #0000;
  transition: box-shadow 0.2s;
}
.segment-box:focus {
  outline: none;
  box-shadow: 0 0 0 1px #b3d4fc;
  background: #e6f0ff;
}
.segment-separator {
  margin: 0 8px;
  font-weight: 400;
font-size: 16px;
color: #000000;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/components/macInput.vue